export default __webpack_public_path__ + "static/media/gunshot - 808 - R_1.ce6499e3.wav";